import React from 'react';
import { StoreConfigContext } from '@helpers/storeConfigContext';

import KoTermsConditions from './ko';
import JaTermsConditions from './ja';

class TermsConditions extends React.Component {
  render() {
    const {
      storeConfig: { language },
    } = this.context;
    if (language == 'ko') {
      return <KoTermsConditions />;
    } else if (language == 'ja') {
      return <JaTermsConditions />;
    } else {
      return <div></div>;
    }
  }
}
    
export default TermsConditions;

TermsConditions.contextType = StoreConfigContext;
